import { render, staticRenderFns } from "./TextFormattingButtons.vue?vue&type=template&id=700e3d72&"
import script from "./TextFormattingButtons.vue?vue&type=script&lang=js&"
export * from "./TextFormattingButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports